<template>
<div class="page page_artDetail">
    <div class="trandsman" >
        <div class="info">
            <img v-if="info" :src="info.thumb ? ($publicData.withHttpStart(info.thumb) ? info.thumb: imageUrl+info.thumb) : $publicData.defaultTouxiang" alt="" class="logo" />
            <span class="name" v-if="info.nickname">{{info.nickname}}</span>
        </div>
        <div class="action">
            <div class="guanzhu" @click="attentionClickFun">{{info.is_attention==1?'已关注':'关注'}}</div>
            <!-- <img :src="publicPath+'statics/images/tuji/share.png'" alt="" class="share" /> -->
        </div>
    </div>
    <!-- 商品 -->
    <div class="yuekan_con" style="padding-top:2rem">
        <div v-for="(customade,index) in customadedata" :key="index">
            <div class="dinghzi" @click="toDingzhiDetail(customade)">
                <van-image class="dingzhi_tu" fit="contain" :show-error="false" :show-loading="false" :src="customade.thumb ? imageUrl+customade.thumb : $publicData.intangibleDefault" />
                <div class="title">{{customade.title}}</div>
                <div class="price">价格￥<span class="real">{{customade.price_range}}</span></div>
                <div class="detail">{{customade.descript}}</div>
                <div class="tips" v-if="customade.customadingnum>0">
                    <div class="tip">已定制</div>
                    <div class="prowrap">
                        <van-progress :percentage="customade.percentage" :pivot-text="customade.customadednum+'件'" color="linear-gradient(-90deg, #DF3434, #FF5F34)" />
                        <div class="percent">{{customade.percentage}}%</div>
                    </div>
                </div>
                <div class="dingzhi_time">
                    <div class="times">
                        <div class="time" v-if="customade.endtime&&customade.endtime>0">
                            <div class="time_t">
                                {{customade.endtime}}
                            </div>
                            <div class="time_d">
                                距定制结束
                            </div>
                        </div>
                        <div class="time" v-if="customade.made_cycle&&customade.made_cycle>0">
                            <div class="time_t">
                                {{customade.made_cycle}}
                            </div>
                            <div class="time_d">
                                制作工期
                            </div>
                        </div>
                        <div class="time" v-if="customade.customadingnum&&customade.customadingnum>0">
                            <div class="time_t">
                                {{customade.customadingnum-customade.customadednum>0?customade.customadingnum-customade.customadednum:0}}
                            </div>
                            <div class="time_d">
                                剩余可定制
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dingzhi_sep"/>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            type: this.$route.query.type,
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
            token: null,
            tradesmanId: this.$route.query.tradesmanId,
            customadedata: [],
            imageUrl: this.$publicData.uploadImage,
            pages: {
                page: 1,
                size: 10
            },
        };
    },
    created: function () {
        // if (this.type == 'b') {
        //     this.active = 'b'
        // }
        console.log('this.active', this.active)
        var that = this
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                'data': {
                    'naviTitle': '匠人定制',
                    levitate: true,
                    showStatusBar: true,
                    // 'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                }
                this.getData()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            }) 
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
		}
		
    },
    mounted: function () {
        console.log('mounted')

    },
    activated: function () {
        console.log('activated')
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            
        } else {
            this.isClient = false
            // 获取列表
            if (this.tradesmanId != this.$route.query.tradesmanId) {
                this.token = this.$store.getters.token
                this.type = this.$route.query.type
                this.tradesmanId = this.$route.query.tradesmanId
                this.active = this.$route.query.type ? this.$route.query.type : 'a'
                this.pages = {
                    page: 1,
                    size: 10
                }
                this.customadedata = []
                this.getData();
            }
            
		}
    },
    methods: {
        getData() {
            this.getDetail()
            this.getGoodsList()
        },
        shareClick() {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                console.log('shareClick')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.info.nickname ? that.info.nickname : that.$publicData.shareDefaultTitleA,
                        detail: that.info.describe ? that.info.describe : '',
                        url: url,
                        platFormType:'',
                        image: that.info.thumb ? that.$publicData.domain + that.info.thumb : that.$publicData.domain + that.$publicData.shareDefaultIcon
                    },
                };
                console.log('params:',params)
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })
            } 
            
        },
        
        getDetail() {
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId
            }
            this.$api.tradesman.detail(param).then(res => {
                if (res.code == 200) {
                    var info = res.result
					this.info = info
					this.register_status = res.result.register_status
					// 未入驻,先判断用户是否为匠人,非匠人方可让他去入驻
					if(this.register_status != 1){
						this.getUserInfo()
					}
                    // 调微信分享参数
					this.getShareData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 匠人下面对应的商品
        getGoodsList() {
            var that = this
            var param = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                page: 1,
                size: 1000
            }
            this.$api.tradesman.goods(param).then(res => {
                if (res.code == 200) {
                    var customadedata = res.result.customadedata
                    for (let i = 0; i < customadedata.length; i++) {
                        const customade = customadedata[i];
                        customade.customadednum = customade.customadednum>0?customade.customadednum:0
                        customade.customadingnum = customade.customadingnum>0?customade.customadingnum:0
                        customade.percentage = (customade.customadednum*1/((customade.customadednum+customade.customadingnum*1)>0?(customade.customadednum+customade.customadingnum*1):100000)*100).toFixed(0)
                    }
                    that.customadedata = customadedata
                    
                }
            })
        },
		// 关注匠人对app和h5进行判断
		attentionClickFun(){
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				//获取用户信息
				var memberParams = {
					data: {},
				};
				this.$bridge.callhandler(
					"sdjy://member/memberInfo",
					memberParams,
					(data) => {
						if (data.code == 200) {
							this.token = data.result.token;
							this.attentionClick();
						}
					}
				);
			} else {
				// console.log('对App和H5做判断')
				this.attentionClick();
			}
		},
		// 关注匠人
        attentionClick() {
            var type = 1
            if (this.info.is_attention == 1) {
                type = 2
            }
            var params = {
                token: this.token,
                tradesman_id: this.tradesmanId,
                type: type
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
                    if (this.info.is_attention == 1) {
                        this.$toast('取消关注成功')
                    } else {
                        this.$toast('关注成功')
                    }
                    this.getDetail()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        toDingzhiDetail(customade) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var url = this.$publicData.clientUrl + '/dingzhi/detail?id=' + customade.id
                var params = {
                    'data': {
                        'url': url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/dingzhi/detail',
                    query: {
                        id: customade.id
                    }
                })
            }
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.nickname ? (that.info.nickname+'定制') : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: that.info.nickname ? (that.info.nickname+'定制') : that.$publicData.shareDefaultTitleA, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.info.thumb ? (that.$publicData.withHttpStart(that.info.thumb) ? that.info.thumb: that.imageUrl+that.info.thumb) : that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
		},
		// 获取分享图片 ** 后台返回的
		getSharePoster(){
			var that = this
			var params = {
				id: that.info.uuid,
				type: 2 // 1商品 2匠人 3直播 4约看
			}
			that.$api.common.shareImg(params).then(res=>{
				if(res.code == 200){
					that.posterUrl = res.result
				}else{
                    that.posterUrl = null
					// that.$toast(res.message)
				}
			})
		},
		// 获取用户角色
		getUserInfo(){
			var params = {
                token: this.token,
                is_cloud: 0 // 非云订单
			}
			this.$api.user.index(params).then(res => {
				if (res.code == 200) {
					this.is_tradesman = res.result.info.userrole.is_tradesman
				}
			})
		},
		// 入驻
		toRegister(){
			var that = this
			if(that.is_tradesman){
				that.$toast('您已是匠人,不可重复申请')
				return
			}else{
				that.$router.push({
					path: '/cooperation/transition'
				})
			}
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dingzhi_sep {
    width: 150%;
    height: 0.26rem;
    margin-left: -0.6rem;
    margin-right: -0.6rem;
    background-color: #f3f4f5;
}
</style>
